import React from 'react';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { useTheme } from 'styled-components';
import { CalloutContainer } from './Callout.styles';

interface Props {
  header: string;
  bodyStyle?: React.CSSProperties;
  onClick?: () => void;
  'data-testid'?: string;
}

export const Callout = (props: Props) => {
  const theme = useTheme();
  return (
    <CalloutContainer
      style={props.bodyStyle}
      showPointer={!!props.onClick}
      onClick={() => {
        if (props.onClick) {
          props.onClick();
        }
      }}
      data-testid={props['data-testid']}
    >
      <StyledIcon
        className="uil uil-lightbulb-alt"
        size="24px"
        color={theme.atlas.semantic.color.type.default}
      />
      {props.header}
    </CalloutContainer>
  );
};
